<template>
  <div>
    <div class="detail-header">
      <div class="header-main content">
        <div>
          <img src="../../static/img/index/headtitle.png">
          <div class="header-search">
            <div class="input-text">
              <input type="text" class="form-control dropdown-toggle" data-toggle="dropdown" placeholder="请输入您要搜索的内容"
                     aria-expanded="false" v-model="key" @keyup.enter="openSearch">
              <span class="input-group-btn">
              <button class="btn btn-warning" type="submit" @click="openSearch">搜 索</button>
            </span>
            </div>
            <div class="hotsearch" @click="openNewPage('https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C79403T4440705001000')">
            </div>
          </div>
        </div>
        <div class="sub-title">路标式政务服务事项解读体系</div>
        <img class="gzjz" src="../../static/img/index/gzjz.png">

      </div>
    </div>
    <div class="Topmatter content">
      <div class="listcon">
        <div class="listname">非学历教育机构设立</div>
        <div class="listbutton">
          <a class="reservation " href="#">在线预约</a>
          <a class="guide " href="https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440102008001">办事指南</a>
        </div>
      </div>
      <div class="ewm">
			<img src="../../static/img/details/ewm.png">
			<div>使用微信扫码登录</div>
		  </div>
    </div>
    <div style="background: #FAFAFB">
      <!--办事解读-->
      <div class="Bsjd content" id="bsjd">
        <div class="conTitle detailConTitle1" ><img src="../../static/img/details/detailTitle-lbsjd.png"></div>
        <div class="left-right">
          <div class="bsjdMain">
            <div class="swiper img-swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <img src="../../static/img/details/jd-img1.png" alt="" @click="openWechat('https://mp.weixin.qq.com/s/CY4xQf3Ldd53s7-S8NKSJQ')">
                </div>
                <div class="swiper-slide">
                  <img src="../../static/img/details/jd-img2.png" alt=""  @click="openWechat('https://mp.weixin.qq.com/s/CY4xQf3Ldd53s7-S8NKSJQ')">
                </div>
              </div>
              <div class="swiper-button-next-img swiper-button-next3"></div>
              <div class="swiper-button-prev-img swiper-button-prev3"></div>
            </div>
          </div>
          <div class="bsjd-table">
            <div class="bsjd-body">
              <div class="title">文件依据</div>
              <div class="bsjd-item" @click="openExplain">
                <div><a target="_blank" href="http://tyj.gd.gov.cn/sjzw_zcfg/content/post_4014027.html">广东省体育局 广东省教育厅关于印发《广东省体育类校外培训机构设置标准（试行）》的通知</a></div>
                <div>2023-05-10</div>
              </div>
              <div class="bsjd-item" @click="openExplain">
                <div><a target="_blank" href="http://gdstc.gd.gov.cn/zwgk_n/zcfg/gfwj/content/post_4014069.html">广东省科学技术厅 广东省教育厅关于印发《广东省科技类校外培训机构设置标准（试行）》的通知</a></div>
                <div>2023-05-10</div>
              </div>
              <div class="bsjd-item" @click="openExplain">
                <div><a target="_blank" href="https://whly.gd.gov.cn/open_newggl/content/post_4037344.html">广东省文化和旅游厅 广东省教育厅关于印发《广东省文化艺术类校外培训机构设置标准（试行）》的通知</a></div>
                <div>2023-05-10</div>
              </div>
              <div class="bsjd-item" @click="openExplain">
                <div><a target="_blank" href="http://edu.gd.gov.cn/ztzlnew/xxl/tzgg/content/post_4065465.html">广东省教育厅等六部门关于印发非学科类校外培训机构办学许可证审批流程指引（试行）的通知</a></div>
                <div>2023-05-10</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!--智能引导-->
      <div class="Znyd content" id="znyd">
        <div class="conTitle detailConTitle"><img src="../../static/img/details/detailTitle-cjsdb.png"></div>
        <div class="znydMain">
          <div class="yd-qx">
            <div class="title-h" style="display: flex">
              <div class="image-c">
                <img src="../../static/img/intelligent/robort.png" alt="">
              </div>
              <div class="title">选择办事情形</div>
            </div>
            <!--            <div class="title">选择办事情形</div>-->
            <div class="yd-qx-list"  >
              <div class="guide-icon guide-icon-active"></div>
              <div class="guide-line-bottom"></div>
              <div class="qx-rom">
                <div class="romtit">1.请选择培训机构营利类型：</div>
                <div class="btn-group">
                  <div class="btn1 active1">非营利性培训机构</div>
                  <div class="btn1">营利性培训机构</div>
                </div>
              </div>
            </div>
            <div class="yd-qx-list"  >
              <div class="guide-icon guide-icon-active"></div>
              <div class="guide-line-top"></div>
              <div class="guide-line-bottom"></div>
              <div class="qx-rom">
                <div class="romtit">2.请选择举办者类型：</div>
                <div class="btn-group">
                  <div class="btn1 active1">社会组织</div>
                  <div class="btn1">个人</div>
                </div>
              </div>
            </div>
            <div class="yd-qx-list"  >
              <div class="guide-icon guide-icon-active"></div>
              <div class="guide-line-top"></div>
              <div class="guide-line-bottom"></div>
              <div class="qx-rom">
                <div class="romtit">3.请选择办学场所类型:</div>
                <div class="btn-group">
                  <div class="btn1 active1">自有场所举办</div>
                </div>
                <div class="rominfo">
                  <label class="radio-inline">
                    <input type="radio" name="handleTypeOptions" checked="">已办理房屋产权证
                  </label>
                  <label class="radio-inline">
                    <input type="radio" name="handleTypeOptions" checked="">未办理房屋产权证
                  </label>
                </div>
              </div>
            </div>
            <div class="yd-qx-list"  >
              <div class="guide-icon guide-icon-active"></div>
              <div class="guide-line-top"></div>
              <div class="guide-line-bottom"></div>
              <div class="qx-rom">
                <div class="romtit">4.请问是否有在线培训业务？：</div>
                <div class="rominfo">
                  <label class="radio-inline">
                    <input type="radio" name="handleTypeOptions" checked="">是
                  </label>
                  <label class="radio-inline">
                    <input type="radio" name="handleTypeOptions" checked="">否
                  </label>
                </div>
              </div>
            </div>
            <div class="yd-qx-list"  >
              <div class="guide-icon"></div>
              <div class="guide-line-top"></div>
              <div class="qx-rom">
                <div class="romtit">5.请选择本学形式：</div>
                <div class="btn-group">
                  <div class="btn1 active1">联合办学（两个以上举办者联合举办）</div>
                  <div class="btn1">单独举办</div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-cl">
            <div class="clMain">
              <div class="cltitle">需要提供的材料(3)</div>
              <div class="cltable">
                <div class="tablehead">
                  <span class="clname">申请材料名称(通用材料)</span>
                  <span class="clzt">状态</span>
                </div>
                <ul>
                  <li>
                    <div class="clname">1.广东省非学科类校外培训机构设立申请表</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">3.营业执照或者其他主体资格证明文件</div>
                    <div class="clzt">免提交</div>
                  </li>
                  <li>
                    <div class="clname">2.开立临时存款账户通知书或企业名称自主申报告知书</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">3.申办报告</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">4.机构章程</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">5.开办资金、注册资本有效证明文件</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">6.培训场所内部结构平面图</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">7.消防安全证明材料</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">8.设施设备情况表</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">9.拟任首届董（理）事会或者其他决策机构组成人员、监事会明细表</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">10.（拟任）校长（行政负责人）履历表</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">11.（拟聘用）从业人员明细表</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">12.培训机构党员名单</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">13.拟用培训材料备案表</div>
                    <div class="clzt">待提供</div>
                  </li>
                </ul>
              </div>
              <div class="cltable">
                <div class="tablehead">
                  <span class="clname">申请材料名称（特殊条件材料【办事情形】)</span>
                  <span class="clzt">状态</span>
                </div>
                <ul>
                  <li>
                    <div class="clname">1.1 非营利性机构：开办资金已全部缴足的验资报告、捐赠协议</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">1.2 营利性培训机构</div>
                    <div class="clzt">免提交</div>
                  </li>
                  <li>
                    <div class="clname">2.1 社会组织：举办者的资质文件（包括营业执照或民办非企业单位登记证书复印件、信用状况良好承诺书，其法定代表人的有效身份证件复印件、法定代表人信用状况良好和无犯罪记录承诺书）</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">2.2 个人： 举办者的资质文件（包括有效身份证件复印件、信用状况良好承诺书、无犯罪记录承诺书）</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">3.1 自有场所举办: 不动产权证、房地产权证或房屋所有权证等，并提供查询内容为房产登记、抵押、查封信息的不动产登记查册表</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">3.1.1 已办理房屋产权证</div>
                    <div class="clzt">免提交</div>
                  </li>
                  <li>
                    <div class="clname">3.1.2 未办理房屋产权证：土地使用权或所有权文件及建设工程报建、验收文件；或镇政府、街道办事处、土地房屋管理部门出具的产权文件等</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">4.1 有在线培训业务：网站（或教育APP）测试账号以及电信与信息服务业务经营（ICP）备案证明等材料</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">4.2 无在线培训业务</div>
                    <div class="clzt">免提交</div>
                  </li>
                  <li>
                    <div class="clname">5.1 联合办学（两个以上举办者联合举办）：联合办学协议</div>
                    <div class="clzt">待提供</div>
                  </li>
                  <li>
                    <div class="clname">5.2 单独举办</div>
                    <div class="clzt">免提交</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="background: #E8F2FF; padding: 1px 0px 20px">
      <!--一件事导办-->
      <div class="yjsdb content" id="yjsdb">
        <div class="conTitle detailConTitle"><img src="../../static/img/details/detailTitle-yjs.png"></div>
        <div class="yjsdbMain">
          <div class="yjsnav">
            <ul class="clearfix">
              <li id="nav_li1" class="LiActive" onclick="setContentTab('nav_li',1,3)"><img
                src="../../static/img/details/db-icon1.png">我要开餐馆</li>
              <li id="nav_li2" class="" onclick="setContentTab('nav_li',2,3)"><img
                src="../../static/img/details/db-icon2.png">我要开饭店</li>
              <li id="nav_li3" class="" onclick="setContentTab('nav_li',3,3)"><img
                src="../../static/img/details/db-icon3.png">我要开酒店</li>
            </ul>
          </div>
          <div class="content-wrap" id="con_nav_li_1">

            <div class="type-wrap">
              <div class="side">
                <ul id="group-list">
                  <li class="" data-group-code="QYSLDJ"><span>企业设立登记</span></li>
                  <li class="" data-group-code="GTGSHZCDJ"><span>个体工商户注册登记</span></li>
                  <li class="active" data-group-code="WSPRPSGWXKZHF"><span>污水排入排水管网许可证核发</span></li>
                  <li class="" data-group-code="GGSP"><span>在城市建筑物、设施上悬挂、张贴宣传品审批 /设置大型户外广告审批</span></li>
                  <li class="" data-group-code="SSSQRCNZDXCY"><span>实施申请人承诺制的小餐饮</span></li>
                  <li class="" data-group-code="JGYSXFBA"><span>竣工验收消防备案</span></li>
                  <li class="" data-group-code="HWZPSZBA"><span>户外招牌设置备案</span></li>
                </ul>
              </div>
              <div class="steps">
                <div class="title" id="flowTitle">我要经营餐饮店铺 新开</div>
                <div class="tabs" id="scenes">
                  <a href="javascript:sceneClick('b09f6e97-d798-43cb-97e6-f7b21f003211')" class="active"
                     title="建筑面积50平以下（平方米）">建筑面积50平以下（平方米）</a>
                  <a href="javascript:sceneClick('1cdcb23c-a6f0-48ae-8921-8bea213c414d')" class=""
                     title="建筑面积50平至10000平（平方米）">建筑面积50平至10000平（平方米）</a>
                  <a href="javascript:sceneClick('02edd816-1aa8-4f42-9db5-5b3d0f2588d3')" class=""
                     title="建筑面积：10000平以上">建筑面积：10000平以上</a>
                </div>
                <img id="step-img" src="../../static/img/details/uploadify1.png" alt="">
              </div>
            </div>
          </div>
          <div class="" id="con_nav_li_2"></div>
          <div class="" id="con_nav_li_3"></div>
        </div>
      </div>
    </div>
    <div>
      <!--一地图-->
      <div class="content hall" id="dtdh">
        <div class="conTitle detailConTitle"><img src="../../static/img/details/detailTitle-dtdh.png"></div>
        <div class="mapContanier" style="padding-top: 0px; padding-bottom: 24px">
          <iframe src="https://thzwb.thnet.gov.cn/icity_pc/#/index" frameborder="0" width="100%" height="1000"></iframe>
        </div>
      </div>
    </div>
    <div>
      <!--政策兑现-->
      <div class="zcdx content" id="zcdx">
        <div class="conTitle detailConTitle"><img src="../../static/img/details/detailTitle-zcdx.png"></div>
        <div class="zcdxmain">
          <div class="jggs">
            <div class="zcdxTitle">兑现事项</div>
            <div class="dxsx-item">
              <div class="info">
                <div class="title1">广州市促进商务高质量发2023年厂展专项资金居民服务业专专项资金居民服务业专</div>
                <div class="desc">广州市商务局 <img src="../../static/img/details/detail-look.png">56人看过</div>
              </div>
              <div class="button-li">
                <div class="btn1">剩2861天</div>
                <div class="btn2">资金支持</div>
              </div>
            </div>
            <div class="zcdxTitle">政策兑换文件</div>
            <ul class="list-body">
              <li>
                <a target="_blank" href="http://thzwb.thnet.gov.cn/policy/#/home">2022年度天河区高端专业服务业政策拟支持名单 (第二批)公示</a>
                <span class="date">2023-02-06</span>
              </li>
              <li>
                <a target="_blank" href="http://thzwb.thnet.gov.cn/policy/#/home">2022年度天河区科技创新政策专项(第五批)拟支持名单公示</a>
                <span class="date">2022-10-18</span>
              </li><li>
              <a target="_blank" href="http://thzwb.thnet.gov.cn/policy/#/home">关于2022年天河科技园/天河软件园高质量 发展政策奖励情况审核结果的公示</a>
              <span class="date">2022-08-29</span>
            </li><li>
              <a target="_blank" href="http://thzwb.thnet.gov.cn/policy/#/home">2022年度天河区科技创新政策专项(第一批)拟支持名单公示 </a>
              <span class="date">2022-08-29</span>
            </li><li>
              <a target="_blank" href="http://thzwb.thnet.gov.cn/policy/#/home">关于2022年天河中央商务区管委会高质量发展政策兑现支持企业名单的公示</a>
              <span class="date">2022-07-27</span>
            </li>
            </ul>
          </div>
          <div class="zcjsq">
            <div class="zcdxTitle">政策计算器</div>
            <div class="zcjsqmain" @click="openNewPage('http://thzwb.thnet.gov.cn/policy/#/calculator')">
              <img src="../../static/img/details/calculator.png">
              <div class="title">政策计算器</div>
              <div class="info">联合申报、协同审批</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--高频事项-->
    <div class="Frequency" id="gpsx" >
      <div class="content">
        <div class="conTitle"><img src="../../static/img/details/detailTitle5.png"></div>
        <div class="freMain">
          <ul>
            <li><a href="https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise2">
              <img src="../../static/img/details/gp-icon1.png">
              <div>内资有限责任公司设立登记</div>
            </a></li>
            <li><a href="https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise3">
              <img src="../../static/img/details/gp-icon1.png">
              <div>内资有限责任公司变更登记</div>
            </a></li>
            <li><a href="https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise6">
              <img src="../../static/img/details/gp-icon2.png">
              <div>企业注册登记档案查询</div>
            </a></li>
            <li><a href="https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise10">
              <img src="../../static/img/details/gp-icon3.png">
              <div>公共场所卫生许可（新证，含改、扩建)</div>
            </a></li>
            <li><a href="https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise13">
              <img src="../../static/img/details/gp-icon2.png">
              <div>公众聚集场所投入使用、营业前消防安全检查（告知承诺件）</div>
            </a></li>
          </ul>
        </div>
      </div>

    </div>
    <!--  左侧导航栏-->
    <div class="Leftnav">
      <ul>
        <li :class="[isInArea1 ? 'Lactive' : '']" @click="scrollToArea(1)"><a>路标式解读</a></li>
        <li :class="[isInArea2 ? 'Lactive' : '']" @click="scrollToArea(2)"><a>场景式导办</a></li>
        <li :class="[isInArea3 ? 'Lactive' : '']" @click="scrollToArea(3)"><a>"一件事" 导航图</a></li>
        <li :class="[isInArea4 ? 'Lactive' : '']" @click="scrollToArea(4)"><a>地图导航</a></li>
        <li :class="[isInArea5 ? 'Lactive' : '']" @click="scrollToArea(5)"><a>政策兑现</a></li>
        <li :class="[isInArea6 ? 'Lactive' : '']" @click="scrollToArea(6)"><a>高频事项</a></li>
      </ul>
    </div>
  </div>
</template>

<style>
@import "../../static/css/bootstrap-icons.css";
@import "../../static/css/bootstrap.min.css";
@import "../../static/css/common.css";
@import "../../static/css/global.css";
@import "../../static/css/details.css";
</style>

<script src="../../static/js/jquery.min.js"></script>
<!-- Page -->
<script src="../../static/js/index.js"></script>
<script>
function setContentTab(name, curr, n) {
  for (i = 1; i <= n; i++) {
    var menu = document.getElementById(name + i);
    var cont = document.getElementById("con_" + name + "_" + i);
    menu.className = i == curr ? "LiActive" : "";
    if (i == curr) {
      cont.style.display = "block";
    } else {
      cont.style.display = "none";
    }
  }
}
</script>
<script>
export default {
  name: "SearchDetail",

  data() {
    return {
      isInArea1: true,
      isInArea2: false,
      isInArea3: false,
      isInArea4: false,
      isInArea5: false,
      isInArea6: false,
      key: "",
    }
  },
  mounted() {
    console.log(this.isInArea5)
    window.addEventListener("scroll", this.handleScroll)
  },

  methods: {
    openSearch() {

    },
    scrollToArea(index) {
      var scale = document.documentElement.clientWidth / 1920; // 分母——设计稿的尺寸
      var e1 = document.getElementById('bsjd').offsetTop *scale;
      var e2 = document.getElementById('znyd').offsetTop *scale;
      var e3 = document.getElementById('yjsdb').offsetTop *scale;
      var e4 = document.getElementById('dtdh').offsetTop *scale;
      var e5 = document.getElementById('zcdx').offsetTop *scale;
      var e6 = document.getElementById('gpsx').offsetTop *scale;
      console.log(e1);
      console.log(e2);
      console.log(e3);
      console.log(e4);
      console.log(e5);
      console.log(e6);
      console.log("///////////");
      var scrollY = index == 1 ? e1 : index == 2 ? e2 : index == 3 ? e3 : index == 4 ? e4 : index == 5 ? e5 : index == 6 ? e6 : 0
      var options = {
        "top": scrollY,
        "left": 0,
        "behavior": "smooth"
      }

      window.scrollTo(options);
    },

    handleScroll() {
      const scrollTop = this.getScroll().top;
      console.log(scrollTop)
      this.isInArea1 = false;
      this.isInArea2 = false;
      this.isInArea3 = false;
      this.isInArea4 = false;
      this.isInArea5 = false;
      this.isInArea6 = false;
      var scale = document.documentElement.clientWidth / 1920; // 分母——设计稿的尺寸
      var e1 = document.getElementById('bsjd').offsetTop *scale;
      var e2 = document.getElementById('znyd').offsetTop *scale;
      var e3 = document.getElementById('yjsdb').offsetTop *scale;
      var e4 = document.getElementById('dtdh').offsetTop *scale;
      var e5 = document.getElementById('zcdx').offsetTop *scale;
      var e6 = document.getElementById('gpsx').offsetTop *scale;
      if (scrollTop < e2-10) {
        this.isInArea1 = true;
      } else if (scrollTop < e3-10) {
        this.isInArea2 = true;
      } else if (scrollTop < e4-10) {
        this.isInArea3 = true;
      }else if (scrollTop < e5-10) {
        this.isInArea4 = true;
      }else if (scrollTop < e6-300) {
        this.isInArea5 = true;
      } else {
        this.isInArea6 = true;
      }
    },

    //获得页面向左、向上卷动的距离
    getScroll() {
      return {
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      };
    },
    openNewPage(url) {
      window.open(url)
    },

    openExplain() {
      let routeData = this.$router.resolve({
        name: 'explain',
      });
      window.open(routeData.href, '_blank')
    },
    openWechat(url) {
      window.open(url, '_blank')
    },

  }
}
</script>







// WEBPACK FOOTER //
// SearchDetail.vue?2dcac304